import { createStore, createTypedHooks, EasyPeasyConfig } from 'easy-peasy'

import { ArticleModel, article } from './article'
import { CategoryModel, category } from './category'
import { ClientModel, client } from './client'
import { EventModel, event } from './event'
import { FacilityModel, facility } from './facility'
import { PromoModel, promo } from './promo'
import { OutletModel, outlet } from './outlet'

export * from './article'
export * from './category'
export * from './client'
export * from './event'
export * from './facility'
export * from './promo'
export * from './outlet'

export interface StoreModel {
	article: ArticleModel
	category: CategoryModel
	client: ClientModel
	event: EventModel
	facility: FacilityModel
	promo: PromoModel
	outlet: OutletModel
}

const storeModel: StoreModel = {
	article,
	category,
	client,
	event,
	facility,
	promo,
	outlet
}

const storeConfig: EasyPeasyConfig = {
	devTools: process.env.NODE_ENV !== 'production'
}

const store = createStore(storeModel, storeConfig)
const typedHooks = createTypedHooks<StoreModel>()

export const { useStoreActions, useStoreDispatch, useStoreState } = typedHooks
export default store
